import styled from 'styled-components';
import React, { useContext, useState } from 'react';
import { ListWrapper, Title, TitleHint } from './components';
import { EditorContext } from '../../../utils/contexts';
import { withEditorPageTracking } from '../../../shared/Tracking';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { FORM_LAYOUTS } from '../constants';
import { FORM_LAYOUT_META as LAYOUT_META } from '../forms/constants';

const LayoutCard = styled.div`
  margin-bottom: 0.67em;
  transition: 0.3s;
  border: 2px solid #dcdcdc;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  position: relative;
  &.active, &:hover { border-color: #636363; }
  img {
    padding: 10px;
    height: 60px;
    width: 60px;
  }
  h6 {
    padding-bottom: 0.25em;
    white-space: nowrap;
    font-size: 0.95em;
    line-height: 133%;
    color: #666;
    font-weight: 600;
  }
  p {
    font-size: 0.9em;
    line-height: 150%;
    color: #888;
    margin: 0;
  }
`;

const RecommendedBadge = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 0.65em;
  font-weight: 700;
  background: #e8562a;
  color: #fff;
  padding: 2px 7px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

function FormLayoutStep({ className }) {
  const history = useHistory();
  const match = useRouteMatch();
  const { dispatch, settings } = useContext(EditorContext);
  const [active, setActive] = useState(settings.type);

  const onSelect = (layout) => {
    setActive(layout);
    dispatch({ type: 'update_type', payload: layout });
    const formId = match.params.formId || 'new';

    try {
      window.analytics?.track('Form Layout Changed', {
        layout,
        form_id: formId,
        site_id: match.params.siteId,
      });
    } catch (_) {}

    history.push(`/sites/${match.params.siteId}/forms/${formId}/design`);
  };

  return (
    <div className={className}>
      <div>
        <Title>Layout</Title>
        <TitleHint>How should your form be displayed?</TitleHint>
      </div>
      <ListWrapper>
        {FORM_LAYOUTS.map((layout) => {
          const meta = LAYOUT_META[layout] || {};
          return (
            <LayoutCard
              key={layout}
              className={active === layout ? 'active' : ''}
              onClick={() => onSelect(layout)}
            >
              {meta.recommended && <RecommendedBadge>Recommended</RecommendedBadge>}
              <h6>{layout === 'Takeover' ? 'Page Takeover' : layout}</h6>
              {meta.icon && <img src={meta.icon} alt={layout} />}
              <p>{meta.description}</p>
            </LayoutCard>
          );
        })}
      </ListWrapper>
    </div>
  );
}

export default styled(withEditorPageTracking(FormLayoutStep, 'Layout'))``;
